import React from "react";
import { useApp } from "@/store";

const CFG = {
  not_submitted: { key: "kyc_not_submitted", cls: "bg-gray-100 text-gray-600 border-gray-200" },
  pending: { key: "kyc_pending", cls: "bg-[#FFF3CD] text-[#856404] border-[#FFEEBA]" },
  approved: { key: "kyc_approved", cls: "bg-[#D4EDDA] text-[#155724] border-[#C3E6CB]" },
  rejected: { key: "kyc_rejected", cls: "bg-red-50 text-red-700 border-red-200" },
};

export default function KycBadge({ status }) {
  const { t } = useApp();
  const c = CFG[status] || CFG.not_submitted;
  return (
    <span data-testid="kyc-status-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-bold tracking-wide ${c.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {t(c.key)}
    </span>
  );
}
